import { connect } from "react-redux";
import CategoryOutOfStock from "../../components/CategoryOutOfStock";
import { getCategoryIsBrand } from "../../state/modules/category";

const mapStateToProps = state => ({
  isBrand: getCategoryIsBrand(state)
});

export default connect(mapStateToProps)(CategoryOutOfStock);
